import { motion } from 'framer-motion';
import { useState } from 'react';

const FlavorCard = ({ flavor, name, description, claims }) => {
  const [rotateX, setRotateX] = useState(0);
  const [rotateY, setRotateY] = useState(0);

  const handleMouseMove = (e) => {
    const card = e.currentTarget;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    const rotateXVal = ((y - centerY) / centerY) * -10;
    const rotateYVal = ((x - centerX) / centerX) * 10;

    setRotateX(rotateXVal);
    setRotateY(rotateYVal);
  };

  const handleMouseLeave = () => {
    setRotateX(0);
    setRotateY(0);
  };

  return (
    <motion.div
      data-testid={`flavor-card-${flavor}`}
      className={`flavor-card ${flavor} p-12 rounded-none min-h-[500px] flex flex-col justify-between cursor-pointer`}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={{
        transform: `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`,
        transition: 'transform 0.1s ease-out',
      }}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <div className="flavor-card-content">
        <div className="text-[#FFB300] font-['Outfit'] text-xs tracking-[0.2em] uppercase mb-4">WAY BIG</div>
        <h3 className="font-['Bebas_Neue'] text-4xl sm:text-5xl text-white uppercase tracking-tight mb-4">{name}</h3>
        <p className="font-['Manrope'] text-base text-white/70 mb-8">{description}</p>
        
        <div className="flex flex-wrap gap-3 mb-8">
          {claims.map((claim, index) => (
            <span
              key={index}
              className="px-4 py-2 border border-[#2A2A2A] text-white/90 text-xs uppercase tracking-wider bg-black/40"
            >
              {claim}
            </span>
          ))}
        </div>
        
        <button
          data-testid={`add-waitlist-btn-${flavor}`}
          data-cursor="JOIN"
          className="w-full bg-[#FF3D00] hover:bg-[#FFB300] text-black font-['Outfit'] font-bold text-sm uppercase tracking-[0.1em] py-4 px-8 border-2 border-[#FF3D00] hover:border-[#FFB300]"
        >
          Join Waitlist
        </button>
      </div>
    </motion.div>
  );
};

export default FlavorCard;